export const CONTACT_EMAIL = 'contact@cedrum.app';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const CONTACT_EMAIL_MARKDOWN_LINK = `[${CONTACT_EMAIL}](${CONTACT_MAILTO})`;

const CONTACT_TOKEN_MAP = Object.freeze({
  '{{CONTACT_EMAIL}}': CONTACT_EMAIL,
  '{{CONTACT_MAILTO}}': CONTACT_MAILTO,
  '{{CONTACT_EMAIL_LINK}}': CONTACT_EMAIL_MARKDOWN_LINK,
});

const UNRESOLVED_TEMPLATE_TOKEN_PATTERN = /\{\{[^{}\r\n]+?\}\}/g;

export function getContactTokenMap() {
  return CONTACT_TOKEN_MAP;
}

export function findUnresolvedTemplateTokens(value) {
  const matches = String(value || '').match(UNRESOLVED_TEMPLATE_TOKEN_PATTERN);
  if (!matches) {
    return [];
  }

  return [...new Set(matches)];
}

export function injectContactTokens(markdown, tokenMap = CONTACT_TOKEN_MAP) {
  let output = String(markdown || '');

  for (const [token, value] of Object.entries(tokenMap)) {
    output = output.split(token).join(value);
  }

  return output;
}
